import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { nissenPageMeta, nissenSchema } from 'components/common/schema'
import Template from 'components/cases/nissen'

const Nissen: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...nissenPageMeta} />
      <JsonLd data={nissenSchema} />
      <Template />
    </>
  )
}

export default Nissen
